import React from 'react'
import { FaqItem } from '../../components/faqitem/FaqItem'
import Page from '../../components/page/Page'

const Faq = (props) => {
    return (
        <Page id="FaqPage">
            <FaqItem
                question={'How can I buy NFTs on NFTHive?'}
                answer={
                    <div>
                        First set up a wallet, using{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href="https://www.mycloudwallet.com/"
                            rel="noreferrer"
                        >
                            MyCloudWallet
                        </a>{' '}
                        or follow the{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href={
                                'https://academy.anyo.io/course/self-managed-account/'
                            }
                            rel="noreferrer"
                        >
                            Guides by Anyobservation
                        </a>
                        . Get some WAXP and login with your wallet. Then you're
                        already good to go!
                    </div>
                }
            />
            <FaqItem
                question={'How can I get $WAXP?'}
                answer={
                    <div>
                        You can buy WAXP on popular crypto exchanges like{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href="https://www.binance.com/"
                            rel="noreferrer"
                        >
                            Binance
                        </a>
                        ,{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href={'https://www.htx.com/'}
                            rel="noreferrer"
                        >
                            HTX
                        </a>
                        ,{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href={'https://okx.com/'}
                            rel="noreferrer"
                        >
                            OKX
                        </a>{' '}
                        or{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href={'https://crypto.com/'}
                            rel="noreferrer"
                        >
                            Crypto.com
                        </a>
                        !
                    </div>
                }
            />
            <FaqItem
                question={'How can I sell my WAX NFTs?'}
                answer={
                    <div>
                        Go to{' '}
                        <a
                            className={'underline'}
                            href={'/account?tab=inventory#Tabs'}
                        >
                            Inventory
                        </a>{' '}
                        to list NFTs on the Market. WAX Marketplaces are linked,
                        so you don't have to worry where to list. People will
                        find your offer if it's reasonable. If you have{' '}
                        <a
                            className={'underline'}
                            href={'/account?tab=sales#Tabs'}
                        >
                            Active Listings
                        </a>{' '}
                        that are not selling, try canceling and relisting or use
                        the{' '}
                        <a
                            className={'underline'}
                            href={'/bulk?search_type=bulk_edit'}
                        >
                            Bulk Tools
                        </a>{' '}
                        to adjust multiple prices and push listings back up.
                    </div>
                }
            />
            <FaqItem
                question={
                    'How can I find which NFTs are missing in my collection?'
                }
                answer={
                    <div>
                        You can either go to the Market and look for{' '}
                        <a
                            className={'underline'}
                            href={
                                '/market?search_type=missing&offer_type=sales'
                            }
                        >
                            "Missing"
                        </a>{' '}
                        Listings, and make sure that you specify your search to
                        the collection and rarity you're interested in, or check
                        if there are <a href={'/collections'}>Collections</a> of
                        the type Collectibles available that have Sets. Sets can
                        be completed from the Set Builder. Some Sets will
                        eventually give you rewards. Look out for that!
                    </div>
                }
            />
            <FaqItem
                question={'How can I find the best prices for WAX NFTs?'}
                answer={
                    <div>
                        NFTHive helps you to filter for{' '}
                        <a
                            className={'underline'}
                            href={
                                '/market?search_type=cheapest&offer_type=sales'
                            }
                        >
                            Floor Prices
                        </a>{' '}
                        of each asset. You can also check the floor prices at
                        the bottom of the cards on the{' '}
                        <a className={'underline'} href={'/market'}>
                            Market
                        </a>
                        .
                    </div>
                }
            />
            <FaqItem
                question={
                    'How can I get notifications for new listings of an Asset, sold items, bids, etc?'
                }
                answer={
                    <div>
                        If you are looking to buy an Asset that is currently not
                        listed or too expensive, you can favorite any Asset by
                        clicking the flag icon on top of the Card. If you chat
                        with{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href={'https://t.me/WAXplorerBot'}
                            rel="noreferrer"
                        >
                            Hive-E
                        </a>{' '}
                        on Telegram, tell them your wallet following the
                        instructions under the /start command. After that,
                        notifications about cheaper listings of that asset will
                        be coming in.
                    </div>
                }
            />
            <FaqItem
                question={'What are HONEY tokens and how do I earn them?'}
                answer={
                    <div>
                        HONEY is a reward Token and can be earned by buying and
                        selling NFTs on NFTHive. HONEY can be staked to earn a
                        share of 33% of our Market fees. For more info, check
                        the{' '}
                        <a className={'underline'} href={'/honey'}>
                            HONEY Page
                        </a>
                        .
                    </div>
                }
            />
            <FaqItem
                question={'How can I create my own NFTs on WAX?'}
                answer={
                    <div>
                        You can use our extensive and free{' '}
                        <a className={'underline'} href={'/creator'}>
                            Creator Tools
                        </a>
                        . You are able to create your own collection, create
                        template and mint NFTs. Additionally you can create NFT
                        Packs, Drop NFTs, creating Crafting Recipes. You can
                        also create PFP drops.
                    </div>
                }
            />
            <FaqItem
                question={'How do I create NFT Packs and Drops on WAX?'}
                answer={
                    <div>
                        To get started, go to our{' '}
                        <a className={'underline'} href={'/creator'}>
                            Creator Tools
                        </a>
                        . We have created a tutorial on how to create your
                        collection, templates, NFTs and ultimately Packs and
                        Drops{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href={
                                'https://medium.com/@hivebp/on-how-to-use-the-nfthive-io-c0a380f69497'
                            }
                            rel="noreferrer"
                        >
                            here
                        </a>
                        .
                    </div>
                }
            />
            <FaqItem
                question={'How does crafting NFTs on WAX work?'}
                answer={
                    <div>
                        Create crafting recipes for your collection in our{' '}
                        <a className={'underline'} href={'/creator'}>
                            Creator Tools
                        </a>
                        . Discover which NFTs can be crafted in the{' '}
                        <a className={'underline'} href={'/crafts'}>
                            Crafting Overview
                        </a>
                        . Select a recipe and check whether you own the
                        necessary ingredients. On NFTHive you can create recipes
                        with multiple outcomes, using NFT or token ingredients.
                        You can decide several ingredient types, like burning,
                        locking or sending assets to a result wallet. Find a
                        tutorial on how to create recipes{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href={
                                'https://medium.com/@hivebp/blend-wax-nfts-on-nfthive-io-57c5b023d30c'
                            }
                            rel="noreferrer"
                        >
                            here
                        </a>
                        . There are also special types of recipes like Mirror
                        Recipes. Mirror Recipes consider traits of two NFTs and
                        will generate new traits based on them. A new NFT will
                        then be rendered. A tutorial on Mirror Recipes can be
                        found{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href={
                                'https://medium.com/@hivebp/mirror-crafts-a-new-way-of-combining-nfts-dd422a29b826'
                            }
                            rel="noreferrer"
                        >
                            here
                        </a>
                        .
                    </div>
                }
            />
            <FaqItem
                question={'How can I create a PFP drop on WAX?'}
                answer={
                    <div>
                        Our exclusive PFP creator is a tool that's quite unique
                        in all of web3. It allows creators to assemble the PFPs
                        layer by layer, rarity by rarity and let an actual smart
                        contract determine the outcomes when they start minting.
                        This means, there are no pre-determined outcomes,
                        everything is proven and fair and randomized on chain,
                        which only an efficient Blockchain like WAX is capable
                        of. The results are also 100% unique, which is ensured
                        by the contract. The images are rendered based on the
                        outcomes and will appear in the buyers wallets after
                        some time. Creators do have the option to add some
                        manual outcomes, which will be drawn randomly before the
                        drop sells out. They can also premint a certain amount
                        of PFPs to their wallet or the NFTHive Pack Creator.
                        More infos on PFP drops can be found{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href={
                                'https://medium.com/@hivebp/pfp-drops-how-to-56138c4ca719'
                            }
                            rel="noreferrer"
                        >
                            here
                        </a>
                        . There are also special types of recipes like Mirror
                        Recipes. Mirror Recipes consider traits of two NFTs and
                        will generate new traits based on them. A new NFT will
                        then be rendered. A tutorial on Mirror Recipes can be
                        found{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href={
                                'https://medium.com/@hivebp/mirror-crafts-a-new-way-of-combining-nfts-dd422a29b826'
                            }
                            rel="noreferrer"
                        >
                            here
                        </a>
                        . <br />
                        NFTs of PFP collections are automatically ranked by{' '}
                        <a className={'underline'} href={'/pfps'}>
                            rarity
                        </a>
                        .
                    </div>
                }
            />
            <FaqItem
                question={'Where can I find the newest Drops on WAX?'}
                answer={
                    <div>
                        On NFTHive you can create your own drops, but you can
                        also find drops from all over the WAX Network. Visit the{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href={'/drops'}
                            rel="noreferrer"
                        >
                            Drops Page
                        </a>{' '}
                        to browse drops of the entire ecosystem.
                    </div>
                }
            />
            <FaqItem
                question={
                    "I need to make many transactions on WAX, but I don't have the resources. What can I do?"
                }
                answer={
                    <div>
                        You can rent CPU temporarily. Send us a small amount of
                        WAX and we'll stake the resources for you temporarily.
                        Visit the{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href={'/cpu'}
                            rel="noreferrer"
                        >
                            CPU Renting Page
                        </a>{' '}
                        for more details.
                    </div>
                }
            />
            <FaqItem
                question={"My Question isn't here. What can I do?"}
                answer={
                    <div>
                        Submit your Question on{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href={'https://t.me/NFTHiveTalk'}
                            rel="noreferrer"
                        >
                            Telegram
                        </a>{' '}
                        or{' '}
                        <a
                            className={'underline'}
                            target="_blank"
                            href={'https://discord.gg/y47qvSmaVu'}
                            rel="noreferrer"
                        >
                            Discord
                        </a>
                        .
                    </div>
                }
            />
        </Page>
    )
}

export default Faq
